import AntdCard from 'antd/lib/card';
import React    from 'react';

export type CardProps = React.ComponentProps<typeof AntdCard>;

const Card = (props: CardProps) => {
	// Map deprecated `bordered` prop to the new `variant` prop to avoid warnings
	// bordered=true  -> variant='outlined'
	// bordered=false -> variant='filled'
	const { bordered, variant, styles, headStyle, bodyStyle, ...rest } = props as any;
	const mappedVariant = variant ?? (typeof bordered === 'undefined' ? undefined : (bordered ? 'outlined' : 'filled'));

	// Map deprecated `headStyle` and `bodyStyle` to the new `styles.header` and `styles.body`
	const mappedStyles = {
		...styles,
		header: styles?.header ?? headStyle,
		body: styles?.body ?? bodyStyle,
	};

	return (
		<AntdCard {...rest} variant={mappedVariant} styles={mappedStyles} />
	);
};

export default Card;
